import { useEffect } from 'react';

/**
 * Hook to warn user before leaving the page
 */
export function useBeforeUnload(condition: boolean, message: string) {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (condition) {
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [condition, message]);
}

